(function() {
  var cartContainer = document.getElementById("CartContainer");
  var checkouts = document.getElementsByName('checkout')
  var checkout = checkouts[checkouts.length - 1];

  var idme = `<div class="idme">
    <div class="idme-shopify">
      <p class='idme-btn-affinity'>Government Employees, Military, and First Responders receive $10 off orders of $25+</p>
      <a class="idme-btn-unify" href="https://discountify.id.me/oauth/checkpoint/rangerreadyrepellents" >
        <img src="https://s3.amazonaws.com/idme/developer/idme-buttons/assets/img/verify.svg" alt="ID.me" style="height:42px"/>
      </a>
    </div>
  </div>`;

    if(cartContainer){
      cartContainer.insertAdjacentHTML("afterend", idme);

      var ajax_classes = document.getElementsByClassName("idme-shopify")[0].classList

      ajax_classes.add("idme-ajax")
      ajax_classes.add("ajaxcart__footer")
      ajax_classes.add("ajaxcart__footer--fixed")
    }

  document.location.pathname === "/cart" && checkout && checkout.insertAdjacentHTML("afterend", idme);
})();

